module.exports = __webpack_public_path__ + "img/box03.abe4a648.png";